import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestConsentClearDelete = {
    path: "/consent/clear",
    method: RouteHttpVerb.DELETE,
    obfuscatePath: "keep-last-part"
};
export { locationRestConsentClearDelete };
